import React from 'react'
import {ErrorMessage, Field} from 'formik'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {BankOption} from '../types'
import {SearchableSelect} from './SearchableSelect'

interface BankAccountFormProps {
  index: number
  bankList: BankOption[]
  branchList: BankOption[]
  showRemoveButton: boolean
  canRemove: boolean
  accountOwnerName: string
  defaultBankOption: string
  defaultBranchOption: string
  isLoadingBanks?: boolean
  isLoadingBranches?: boolean
  onSelectChange: (
    event: React.ChangeEvent<HTMLSelectElement>,
    fieldName: string,
    index: number
  ) => void
  onRemove: (event: React.MouseEvent<HTMLButtonElement>, index: number) => void
}

export const BankAccountForm: React.FC<BankAccountFormProps> = ({
  index,
  bankList,
  branchList,
  showRemoveButton,
  canRemove,
  accountOwnerName,
  defaultBankOption,
  defaultBranchOption,
  isLoadingBanks = false,
  isLoadingBranches = false,
  onSelectChange,
  onRemove,
}) => {
  return (
    <div>
      {showRemoveButton && index >= 1 && (
        <div className='d-flex align-items-center'>
          <h3 className='fw-bolder m-0'>Tài khoản ngân hàng {index + 1}</h3>
          <button
            className='bg-transparent border-0'
            onClick={(e) => onRemove(e, index)}
            disabled={!canRemove}
            type='button'
          >
            <img
              className=''
              alt='Remove bank account'
              src={toAbsoluteUrl('/media/nhsv/minus-circle.png')}
            />
          </button>
        </div>
      )}

      {/* Bank Name Selection */}
      <div className='fv-row mt-5 mb-5'>
        <label className='form-label'>
          Tên ngân hàng <span className='text-danger'>*</span>
        </label>
        <Field name={`bank_cd_off_${index + 1}`}>
          {({field, form}: any) => (
            <div>
              <SearchableSelect
                options={bankList}
                value={field.value || ''}
                placeholder='Chọn tên ngân hàng'
                loadingText='Đang tải...'
                isLoading={isLoadingBanks}
                disabled={isLoadingBanks}
                onSelect={(selectedValue) => {
                  // Update Formik field
                  form.setFieldValue(field.name, selectedValue)

                  // Trigger the original onChange handler
                  const syntheticEvent = {
                    target: {value: selectedValue},
                  } as React.ChangeEvent<HTMLSelectElement>
                  onSelectChange(syntheticEvent, `bank_cd_off_${index + 1}`, index)
                }}
                className='w-100'
              />
            </div>
          )}
        </Field>
        <div className='text-danger mt-2'>
          <ErrorMessage component='span' name={`bank_cd_off_${index + 1}`} />
        </div>
      </div>

      {/* Bank Branch Selection */}
      <div className='fv-row mt-5 mb-5'>
        <label className='form-label'>
          Chi nhánh ngân hàng <span className='text-danger'>*</span>
        </label>
        <Field name={`bank_brch_cd_${index + 1}`}>
          {({field, form}: any) => (
            <div>
              <SearchableSelect
                options={branchList}
                value={field.value || ''}
                placeholder='Chọn tên chi nhánh'
                loadingText='Đang tải chi nhánh...'
                isLoading={isLoadingBranches}
                disabled={isLoadingBranches || branchList.length === 0}
                onSelect={(selectedValue) => {
                  // Update Formik field
                  form.setFieldValue(field.name, selectedValue)

                  // Trigger the original onChange handler
                  const syntheticEvent = {
                    target: {value: selectedValue},
                  } as React.ChangeEvent<HTMLSelectElement>
                  onSelectChange(syntheticEvent, `bank_brch_cd_${index + 1}`, index)
                }}
                className='w-100'
              />
              {branchList.length === 0 && !isLoadingBranches && (
                <small className='text-muted mt-1 d-block'>
                  <i className='fas fa-info-circle me-1'></i>
                  Vui lòng chọn ngân hàng trước
                </small>
              )}
            </div>
          )}
        </Field>
        <div className='text-danger mt-2'>
          <ErrorMessage component='span' name={`bank_brch_cd_${index + 1}`} />
        </div>
      </div>

      {/* Account Number */}
      <div className='fv-row mt-5 mb-5'>
        <label className='fs-6 fw-bold form-label mb-3'>Số tài khoản</label>
        <Field
          name={`bank_acnt_no_${index + 1}`}
          placeholder='Nhập Số tài khoản'
          className='form-control form-control-lg form-control-solid'
        />
        <div className='text-danger mt-2'>
          <ErrorMessage component='span' name={`bank_acnt_no_${index + 1}`} />
        </div>
      </div>

      {/* Account Owner Name */}
      <div className='fv-row mt-5 mb-5'>
        <label className='fs-6 fw-bold form-label mb-3'>Tên chủ tài khoản</label>
        <input
          disabled
          className='form-control form-control-lg'
          placeholder='Chủ tài khoản'
          value={accountOwnerName}
        />
      </div>
    </div>
  )
}
